module.exports = __webpack_public_path__ + "img/72_explorer.9de8e74b.jpg";